/**
 * Private modules
 */
const {
  compositeKey,
  createQueryComponent,
  locale,
  type,
} = require('../.private').components;

module.exports = {
  getDrawSystemGameTypeInvoiceByCompositeKey: {
    properties: {
      params: {
        properties: {
          compositeKey,
        },
        required: ['compositeKey'],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  printDrawSystemGameTypeInvoiceByCompositeKey: {
    properties: {
      body: {
        properties: {
          locale,
          type,
        },
        required: [
          'locale',
          'type',
        ],
        type: 'object',
      },
      params: {
        properties: {
          compositeKey,
        },
        required: ['compositeKey'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  shareDrawSystemGameTypeInvoiceByCompositeKey: {
    properties: {
      body: {
        properties: {
          locale,
          type,
        },
        required: [
          'locale',
          'type',
        ],
        type: 'object',
      },
      params: {
        properties: {
          compositeKey,
        },
        required: ['compositeKey'],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
};
